import styled from 'styled-components'
import themeGet from '@styled-system/theme-get'

import { Flex } from 'Components/UI'
import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

import { LANDING_INLINE_PADDINGS } from 'Constants/Landing'

const shouldForwardProp = prop => {
  return !DIV_SHOULD_FORWARD_PROP.includes(String(prop))
}

export const Container = styled(Flex).attrs({
  px: LANDING_INLINE_PADDINGS,
  pt: [16, 16, 16, 16, 8],
  pb: [0, 0, 32, 40, 0],
})`
  background-color: ${themeGet('colors.bg.primary')};
  width: 100%;
  justify-content: center;
  overflow: hidden;
`

export const Content = styled(Flex)
  .attrs({
    flexDirection: ['column', 'column', 'row'],
  })
  .withConfig({
    shouldForwardProp,
  })`
  align-items: center;
  width: 100%;
`

export const CropContainer = styled(Flex)
  .attrs({
    top: [0, 0, 0, 0, 200],
    width: [0, 0, 0, 0, 80],
    height: [0, 0, 0, 0, 180],
  })
  .withConfig({
    shouldForwardProp,
  })`
  right: 0;
  overflow: hidden;
  position: absolute;
`

export const TextHolder = styled(Flex)
  .attrs({
    width: [1, 1, 315, 500, 500],
  })
  .withConfig({
    shouldForwardProp,
  })`
  justify-content: center;
  flex-direction: column;
  flex-shrink: 0;
`

export const TitleHolder = styled(Flex)
  .attrs({
    flexDirection: ['row', 'row', 'column', 'row'],
  })
  .withConfig({
    shouldForwardProp,
  })``

export const ImageHolder = styled(Flex)
  .attrs({
    height: [300, 300, 450, 450, 720],
    width: [1, 1, 'auto'],
  })
  .withConfig({
    shouldForwardProp,
  })``
